module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_new_product-239edd208a080d3d9b1207d9c4a987a7.jpg";